var map = {
	"./qy8/json/about02.json": 304,
	"./qy8/json/about_en-US.json": 305,
	"./qy8/json/about_hi-IN.json": 306,
	"./qy8/json/about_zh-TW.json": 307,
	"./qy8/json/customerAll.json": 308,
	"./qy8/json/disclaimer02.json": 309,
	"./qy8/json/flexLeft.json": 184,
	"./qy8/json/flexRight.json": 185,
	"./qy8/json/floatBtn.json": 182,
	"./qy8/json/head.json": 310,
	"./qy8/json/hotGame.json": 311,
	"./qy8/json/idxApp.json": 312,
	"./qy8/json/idxContact.json": 313,
	"./qy8/json/idxFmenu.json": 186,
	"./qy8/json/idxFooter.json": 183,
	"./qy8/json/idxInfo.json": 314,
	"./qy8/json/layout.json": 315,
	"./qy8/json/m_floatBtn.json": 316,
	"./qy8/json/novice_en-US.json": 317,
	"./qy8/json/novice_hi-IN.json": 318,
	"./qy8/json/novice_zh-TW.json": 319,
	"./qy8/json/question_en-US.json": 320,
	"./qy8/json/question_hi-IN.json": 321,
	"./qy8/json/question_zh-TW.json": 322,
	"./qy8/json/rule02.json": 323,
	"./qy8/json/seo.json": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;